<script>
	import { onMount } from 'svelte';
	import { page } from '$app/stores';
	import { isLoading } from 'svelte-i18n';
	import Header from '$lib/components/Header.svelte';
	import Footer from '$lib/components/Footer.svelte';
	import GoogleAdsense from "./Adsense.svelte";
	import {PUBLIC_ADS} from "$env/static/public";
	import '$lib/i18n';
	import { setupI18n } from '$lib/i18n/utils';
	import '../app.css';

	export let data;

	onMount(() => {
		setupI18n($page.url.pathname);
	});
</script>

{#if $isLoading}
	<div class="loading-container">
		<div class="loading-spinner"></div>
		<p>Loading...</p>
	</div>
{:else}
	<div class="app">
		<GoogleAdsense enabled={PUBLIC_ADS==='true'?true:false} />
		<Header></Header>
		<main>
			<slot></slot>
		</main>
		<Footer></Footer>
	</div>
{/if}

<style>
	.app {
		display: flex;
		flex-direction: column;
		min-height: 100vh;
	}

	main {
		flex: 1;
	}
	
	.loading-container {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		min-height: 100vh;
		gap: 1rem;
	}
	
	.loading-spinner {
		width: 2rem;
		height: 2rem;
		border: 3px solid #f3f3f3;
		border-top: 3px solid #3498db;
		border-radius: 50%;
		animation: spin 1s linear infinite;
	}
	
	@keyframes spin {
		0% { transform: rotate(0deg); }
		100% { transform: rotate(360deg); }
	}
</style>